import { Box, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TituloRubrica = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const handleTitulo = (event) => {
    const titulo = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        titulo: titulo 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mb:2}}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'row',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
          Título de la actividad *
        </Typography>
        </Box>
        <TextField
          fullWidth
          value={promptData.titulo}
          variant="outlined"
          placeholder="Escribe aquí el título de la actividad. Ejemplo: Convenciendo a nuestra comunidad escolar de comer saludable"
          onChange={handleTitulo}
          InputProps={{
            sx: {
              borderRadius:2,
              fontFamily: 'montserrat',  
              fontSize: '0.75rem',          
              color: '#336B87',        
            }
          }}
          sx={{ 
            fontFamily: 'montserrat', 
            fontSize: '0.75rem', 
            color: '#336B87', 
            '& fieldset': { borderColor: '#Divider' }, 
            '&:before': { borderColor: '#Divider' }, 
            '&:after': { borderColor: '#Divider' } 
          }}
        />
      </Box>
    </Grid>
  );
};

export default TituloRubrica;